import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.a`
  display: block;
  float: left;
  padding: 12px;
  border-radius: 26px;

  transition: background-color 0.3s;

  &:hover {
    background-color: ${props => props.color || "#4A90E2"};
  }
`;

const Icon = styled.span`
  background: url(${props => props.src});
  background-repeat: no-repeat;
  width: 28px;
  height: 28px;
  background-size: contain;
  text-indent: -9000em;
  display: block;
  float: left;
`;


function wrap(color, name) {
  return (props) => (
    <Wrapper {...props} color={color}>
      <Icon src={`/images/social/${name}-logo.svg`} />
    </Wrapper>
  );
};

export const DribbbleLink = wrap("#F7399F", "dribbble");
export const GithubLink = wrap("#707070", "github");
export const LinkedinLink = wrap("#497EB4", "linkedin");

export default {};



// WEBPACK FOOTER //
// ./src/components/ui/SocialLink.js